import mock from 'utils/mock';

mock.onGet('/api/billing').reply(200, {
  current: { date: '2020-06-30T00:00:00.000Z', amount: '1,018.00' },
  data: [
    {
      date: '2020-06-30T00:00:00.000Z',
      charge: '506.00',
      transfer: '306.00',
      linkPay: '206.00',
      total: '1018.00',
      status: 'Paid'
    },
    {
      date: '2020-05-31T00:00:00.000Z',
      charge: '505.00',
      transfer: '305.00',
      linkPay: '205.00',
      total: '1015.00',
      status: 'Paid'
    },
    {
      date: '2020-04-30T00:00:00.000Z',
      charge: '504.00',
      transfer: '304.00',
      linkPay: '204.00',
      total: '1012.00',
      status: 'Paid'
    },
    {
      date: '2020-03-31T00:00:00.000Z',
      charge: '503.00',
      transfer: '303.00',
      linkPay: '203.00',
      total: '1009.00',
      status: 'Paid'
    },
    {
      date: '2020-02-29T00:00:00.000Z',
      charge: '502.00',
      transfer: '302.00',
      linkPay: '202.00',
      total: '1006.00',
      status: 'Paid'
    },
    {
      date: '2020-01-31T00:00:00.000Z',
      charge: '501.00',
      transfer: '301.00',
      linkPay: '201.00',
      total: '1003.00',
      status: 'Paid'
    }
  ]
});

mock.onGet('/api/billing/1').reply(200, {
  data: {
    invoiceNo: 'IN010026',
    invoiceDate: '2020-01-31T00:00:00.000Z',
    customer: {
      name: 'Tracey Herman',
      company: 'Help me write code',
      address: '271 Richmond Rd, Grey Lynn, Auckland 1022, New Zealand',
      phone: '0810000000',
      email: 'sampl2@mail.com'
    },
    charge: [
      { name: 'ThaiQR', qty: '20,000.00', unit: '1%', amount: '200.00' },
      { name: 'QRCS', qty: '5,900.00', unit: '3.5%', amount: '206.50' },
      { name: 'Alipay', qty: '4,500.00', unit: '1.65%', amount: '74.25' },
      { name: 'Wechat', qty: '1,200.00', unit: '1.65%', amount: '19.80' }
    ],
    transfer: [
      { name: 'Half day', qty: '7', unit: '30', amount: '210.00' },
      { name: 'Daily', qty: '6', unit: '15', amount: '90.00' }
    ],
    linkPay: [{ name: 'ThaiQR', qty: '40', unit: '5', amount: '200.00' }],
    totalService: '1,000.55',
    tax: '30.01',
    totalAmount: '1,030.56'
  }
});
